import { DomRefContext } from 'page-context/domRef/domRefProvider.js';
import { useContext } from 'react';
import { STICKY_BAR_PRIMARY_SELECTOR } from 'utilities/consts.js';

export const StickyBar = ({ name, children }: { name?: string; children: JSX.Element }) => {
  const { primarySectionDomRef } = useContext(DomRefContext);

  return (
    <section
      id={STICKY_BAR_PRIMARY_SELECTOR}
      ref={(el: HTMLDivElement) => primarySectionDomRef?.setDomRef(el)}
      className="App-primary"
      data-layout={name}
    >
      {children}
    </section>
  );
};
